import Vue from "vue";
import Router from "vue-router";

//Dashboard 首页

Vue.use(Router);

export let routers = [
  {
    path: "/",
    name: "index",
    component: () => import("@/pages/index.vue"),
    redirect: "/employeeList",
    meta: {
      title: "首页"
    },
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/pages/home/home.vue")
      },
      {
        //员工列表
        path: "/employeeList",
        name: "employeeList",
        component: () => import("@/pages/employee/employeeList.vue")
      },
      {
        //员工列表
        path: "/workClockIn",
        name: "workClockIn",
        component: () => import("@/pages/employee/workClockIn/workClockIn.vue")
      },
      {
        //员工列表
        path: "/questionnaire",
        name: "questionnaire",
        component: () =>
          import("@/pages/employee/questionnaire/questionnaire.vue")
      },
      {
        //餐厅列表
        path: "/restaurantList",
        name: "restaurantList",
        component: () => import("@/pages/restaurant/restaurantList.vue")
      },
       {
        //餐厅列表
        path: "/merchant",
        name: "merchant",
        component: () => import("@/pages/userManagement/merchant/merchant.vue")
      },
      {
        //员工列表
        path: "/userList",
        name: "userList",
        component: () => import("@/pages/userManagement/user/userList.vue")
      },

      {
        //菜单列表
        path: "/menuList",
        name: "menuList",
        component: () => import("@/pages/userManagement/menu/menuList.vue")
      },
      {
        //角色列表
        path: "/roleList",
        name: "roleList",
        component: () => import("@/pages/userManagement/role/roleList.vue")
      },
      {
        //角色列表
        path: "/assistList",
        name: "assistList",
        component: () => import("@/pages/userManagement/assist/assistList.vue")
      },
      {
        //角色列表
        path: "/operateLog",
        name: "operateLog",
        component: () =>
          import("@/pages/userManagement/operateLog/operateLog.vue")
      },
      {
        //角色列表
        path: "/assistStatistics",
        name: "assistStatistics",
        component: () =>
          import("@/pages/userManagement/assist/assistStatistics.vue")
      },
      {
        //角色列表
        path: "/clientuser",
        name: "clientuser",
        component: () =>
          import("@/pages/userManagement/clientuser/clientuser.vue")
      },
      {
        //角色列表
        path: "/referrer",
        name: "referrer",
        component: () => import("@/pages/userManagement/referrer/referrer.vue")
      },
      {
        //餐厅列表
        path: "/groupList",
        name: "groupList",
        component: () => import("@/pages/restaurant/group/groupList.vue")
      },
      {
        //审核列表
        path: "/auditEmployeelist",
        name: "auditEmployeelist",
        component: () =>
          import("@/pages/employee/auditEmployee/auditEmployeelist.vue")
      },
      {
        //通知列表
        path: "/noticesList",
        name: "noticesList",
        component: () => import("@/pages/notices/noticesList.vue")
      },
      {
        //留言类型
        path: "/leaveMessage",
        name: "leaveMessage",
        component: () => import("@/pages/notices/leaveMessage/leaveMessage.vue")
      },
      {
        //留言记录
        path: "/messageRecord",
        name: "messageRecord",
        component: () =>
          import("@/pages/notices/messageRecord/messageRecord.vue")
      },
      {
        //排版信息
        path: "/scheduling",
        name: "scheduling",
        component: () => import("@/pages/scheduling/scheduling.vue")
      },
      {
        //打卡标签
        path: "/workTag",
        name: "workTag",
        component: () => import("@/pages/scheduling/workTag/workTag.vue")
      },
      {
        //地区
        path: "/districts",
        name: "districts",
        component: () => import("@/pages/restaurant/districts/districts.vue")
      },
      {
        //客服
        path: "/customer",
        name: "customer",
        component: () => import("@/pages/scheduling/customer/customer.vue")
      },
      {
        //同步排班
        path: "/synchronous",
        name: "synchronous",
        component: () =>
          import("@/pages/scheduling/synchronous/synchronous.vue")
      },
      {
        //离职员工列表
        path: "/leavesPerson",
        name: "leavesPerson",
        component: () =>
          import("@/pages/employee/leavesPerson/leavesPerson.vue")
      },
      {
        //d导出粮表
        path: "/derivedgrain",
        name: "derivedgrain",
        component: () =>
          import("@/pages/scheduling/derivedgrain/derivedgrain.vue")
      },
      {
        //出粮检查
        path: "/salaryPaymentCheck",
        name: "salaryPaymentCheck",
        component: () =>
          import("@/pages/scheduling/salaryPaymentCheck/salaryPaymentCheck.vue")
      },
      {
        //d导出粮表
        path: "/workuse",
        name: "workuse",
        component: () =>
          import("@/pages/scheduling/workuse/workuse.vue")
      }
    ]
  }
];

export const router = new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/pages/login/login.vue")
    }
  ]
});

//全局路由守卫
router.beforeEach((to, from, next) => {
  if (localStorage.getItem("token") || to.path === "/login") {
    localStorage.setItem("nowPath", to.fullPath);
    next();
  } else {
    next("/login");
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js